import { render, staticRenderFns } from "./HomeM.vue?vue&type=template&id=bdc50f52&scoped=true"
import script from "./HomeM.vue?vue&type=script&lang=js"
export * from "./HomeM.vue?vue&type=script&lang=js"
import style0 from "./HomeM.vue?vue&type=style&index=0&id=bdc50f52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc50f52",
  null
  
)

export default component.exports